import { render, staticRenderFns } from "./createSubdivisions.vue?vue&type=template&id=33286429&scoped=true"
import script from "./createSubdivisions.vue?vue&type=script&lang=js"
export * from "./createSubdivisions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33286429",
  null
  
)

export default component.exports